export const aggregationConstants = {
  AGGREGATION_LIST_REQUEST: 'AGGREGATION_LIST_REQUEST',
  AGGREGATION_LIST_SUCCESS: 'AGGREGATION_LIST_SUCCESS',
  AGGREGATION_LIST_FAILURE: 'AGGREGATION_LIST_FAILURE',
  AGGREGATION_LIST_CHANGED: 'AGGREGATION_LIST_CHANGED',
  AGGREGATION_LIST_PAGINATION: 'AGGREGATION_LIST_PAGINATION',
  AGGREGATION_LIST_CLEAR_PAGINATION: 'AGGREGATION_LIST_CLEAR_PAGINATION',
};
